<template>
  <div class="setComponent">
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="form-setting" size="medium">
      <!-- 显示及皮肤 -->
      <div class="title">
        <h4>{{$t("wm_lang_html_918362")}}</h4>
        <el-divider></el-divider>
      </div>
      <el-form-item :label="$i18n.t('wm_lang_6b0fd2')" prop="select" class="m-list">
        <span>{{$t("wm_lang_html_7cf1f5")}}</span>
        <el-select v-model="ruleForm.pageSize" :placeholder="$i18n.t('wm_lang_708c9d')">
          <el-option label="20" :value="20"></el-option>
          <el-option label="50" :value="50"></el-option>
          <el-option label="100" :value="100"></el-option>
        </el-select>
        <span>{{$t("wm_lang_html_6a3db1")}}</span>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_185839')" prop="radio">
        <el-radio-group v-model="ruleForm.layout">
          <el-radio :label="1">{{$t("wm_lang_html_ac8ccc")}}</el-radio>
          <el-radio :label="2">{{$t("wm_lang_html_f1d5f5")}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_9ef16d')" prop="radio">
        <el-radio-group v-model="ruleForm.toolbarButtonIcon">
          <el-radio :label="true">{{$t("wm_lang_html_5ef69f")}}</el-radio>
          <el-radio :label="false">{{$t("wm_lang_html_ca746b")}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_b5771a')" prop="radio">
        <el-radio-group v-model="ruleForm.loginRouterPage">
          <el-radio :label="1">{{$t("wm_lang_html_db1c89")}}</el-radio>
          <el-radio :label="2">{{$t("wm_lang_html_e75969")}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_2e28bb')" prop="radio">
        <el-radio-group v-model="ruleForm.recvFromDisplay">
          <el-radio :label="1">{{$t("wm_lang_html_bf74e9")}}</el-radio>
          <el-radio :label="2">{{$t("wm_lang_html_8f4f08")}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--<el-form-item label=this.$i18n.t('wm_lang_348913') prop="select">-->
        <!--<el-select v-model="ruleForm.webmailSkin" placeholder=this.$i18n.t('wm_lang_708c9d')>-->
          <!--<el-option label=this.$i18n.t('wm_lang_c33c30') :value="1"></el-option>-->
          <!--<el-option label=this.$i18n.t('wm_lang_0d8f65') :value="2"></el-option>-->
          <!--<el-option label=this.$i18n.t('wm_lang_992cd2') :value="3"></el-option>-->
          <!--<el-option label=this.$i18n.t('wm_lang_5f10ee') :value="4"></el-option>-->
          <!--<el-option label=this.$i18n.t('wm_lang_66c3e5') :value="5"></el-option>-->
          <!--<el-option label=this.$i18n.t('wm_lang_d3950d') :value="6"></el-option>-->
          <!--<el-option label=this.$i18n.t('wm_lang_0807a3') :value="7"></el-option>-->
          <!--<el-option label=this.$i18n.t('wm_lang_0182f1') :value="8"></el-option>-->
          <!--<el-option label=this.$i18n.t('wm_lang_abb501') :value="9"></el-option>-->
        <!--</el-select>-->
      <!--</el-form-item>-->
       <el-form-item :label="'WebMail'+$i18n.t('wm_lang_295bb7')" prop="select">
         <el-select v-model="ruleForm.language" :placeholder="$i18n.t('wm_lang_708c9d')">
           <el-option :label="$i18n.t('wm_lang_0b2f8e')" :value="1"></el-option>
           <el-option :label="$i18n.t('wm_lang_aef8cb')" :value="2"></el-option>
           <el-option :label="$i18n.t('wm_lang_f9fb6a')" :value="3"></el-option>
         </el-select>
       </el-form-item>
    <!--</el-form>-->
    <br><br>

    <!-- 发信设置 -->
    <div class="title">
      <h4>{{$t("wm_lang_html_6b05b5")}}</h4>
      <el-divider></el-divider>
    </div>
    <!-- 表单 -->
    <!--<el-form :model="ruleForm" ref="ruleForm" label-width="180px" class="form-setting" size="medium">-->
      <el-form-item :label="$i18n.t('wm_lang_14fe7d')" prop="customName">
        <el-radio-group v-model="ruleForm.sendFromDisplay" :disabled="sendFromDisplayEnable">
          <el-radio :label="1">{{$t("wm_lang_html_2064fc")}}</el-radio>
          <el-radio :label="2">{{$t("wm_lang_html_7eacb4")}}</el-radio>
          <el-radio :label="3">{{$t("wm_lang_html_f1d4ff")}}</el-radio>
        </el-radio-group>
          <el-input v-show="false" v-model="realName"></el-input>
          <el-input v-show="ruleForm.sendFromDisplay === 3" v-model="ruleForm.customName"></el-input>
          <span
            slot="error"
            slot-scope="scope"
            class="el-form-item__error custom-name-error"
          >{{ scope.error }}</span>
        <p v-show="!customSenderNameStatus" class="c_red">{{$t("wm_lang_html_e0f673")}}</p>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_1b3bf0')" prop="select" class="m-list">
        <el-select v-model="ruleForm.fontName" :placeholder="$i18n.t('wm_lang_9f22bc')">
          <el-option :label="$i18n.t('wm_lang_971f54')" :value="'微软雅黑'"></el-option>
          <el-option :label="$i18n.t('wm_lang_71b068')" :value="'宋体'"></el-option>
          <el-option :label="$i18n.t('wm_lang_e0b004')" :value="'黑体'"></el-option>
          <el-option :label="$i18n.t('wm_lang_2cff3b')" :value="'仿宋'"></el-option>
          <el-option :label="$i18n.t('wm_lang_02aaf1')" :value="'楷体'"></el-option>
          <el-option :label="$i18n.t('wm_lang_168dfa')" :value="'隶书'"></el-option>
          <el-option :label="$i18n.t('wm_lang_68018f')" :value="'幼圆'"></el-option>
          <el-option label="Andale Mono" :value="'andale mono,times'"></el-option>
          <el-option label="Arial" :value="'arial,helvetica,sans-serif'"></el-option>
          <el-option label="Arial Black" :value="'arial black,avant garde'"></el-option>
          <el-option label="Book Antiqua" :value="'book antiqua,palatino'"></el-option>
          <el-option label="Comic Sans MS" :value="'comic sans ms,sans-serif'"></el-option>
          <el-option label="Courier New" :value="'courier new,courier'"></el-option>
          <el-option label="Georgia" :value="'georgia,palatino'"></el-option>
          <el-option label="Helvetica" :value="'helvetica'"></el-option>
          <el-option label="Impact" :value="'impact,chicago'"></el-option>
          <el-option label="Symbol" :value="'symbol'"></el-option>
          <el-option label="Tahoma" :value="'tahoma,arial,helvetica,sans-serif'"></el-option>
          <el-option label="Terminal" :value="'terminal,monaco'"></el-option>
          <el-option label="Times New Roman" :value="'times new roman,times'"></el-option>
          <el-option label="Trebuchet MS" :value="'trebuchet ms,geneva'"></el-option>
          <el-option label="Verdana" :value="'verdana,geneva'"></el-option>
          <el-option label="Webdings" :value="'webdings'"></el-option>
          <el-option label="Wingdings" :value="'wingdings'"></el-option>
        </el-select>
        <el-select v-model="ruleForm.fontSize" :placeholder="$i18n.t('wm_lang_44a0b8')">
          <el-option label="12" :value="12"></el-option>
          <el-option label="14" :value="14"></el-option>
          <el-option label="16" :value="16"></el-option>
          <el-option label="18" :value="18"></el-option>
          <el-option label="20" :value="20"></el-option>
          <el-option label="24" :value="24"></el-option>
          <el-option label="36" :value="36"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_be5fbb')+'Web'+this.$i18n.t('wm_lang_d3637f')">
        <el-form-item label="" prop="switch">
          <el-switch v-model="ruleForm.webSent"></el-switch>
        </el-form-item>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_05e8d4')" prop="radio">
        <el-form-item label="" prop="switch">
          <el-switch v-model="ruleForm.receipt"></el-switch>
        </el-form-item>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_5ea696')" prop="radio">
        <el-form-item label="" prop="switch">
          <el-switch v-model="ruleForm.replyWithContent"></el-switch>
        </el-form-item>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_1edff0')+'/'+$i18n.t('wm_lang_d17143')" prop="radio">
        <el-radio-group v-model="ruleForm.replySubjectPrefix">
          <el-radio :label="1">Re:/Fw:</el-radio>
          <el-radio :label="2">{{$t("wm_lang_html_1edff0")}}:/{{$t("wm_lang_html_21e106")}}:</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_7deb96')" prop="radio">
        <el-radio-group v-model="ruleForm.orgVisible">
          <el-radio :label="true">{{$t("wm_lang_html_31c7ca")}}</el-radio>
          <el-radio :label="false">{{$t("wm_lang_html_6b8677")}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_28cf54')" prop="ccDef">
        <el-input v-model="ruleFormCcDef" :placeholder="$i18n.t('wm_lang_ba6025')"></el-input>
        <input type="hidden" v-model="ruleForm.ccDef">
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_cb0804')" prop="bccDef">
        <el-input v-model="ruleFormBccDef" :placeholder="$i18n.t('wm_lang_ba6025')"></el-input>
        <input type="hidden" v-model="ruleForm.bccDef">
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
      </el-form-item>
    </el-form>
    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
import Cookies from 'js-cookie';
import storeLocal from 'store';
import { isEmail } from '@/utils/validate';
import { bitIs1 } from '@/utils/utils';

export default {
  name: 'generalSettings',
  data () {
    let checkDefaultCcAddrs = (rule,value,callback) => {
      let errorflag = false;
      let addr = this.ruleFormCcDef;
      if(addr) {
        let arr = addr.split(",");
        if(arr.length > 3){
          errorflag = true;
        }else {
          for(let i= 0;i<arr.length;i++){
            if(isEmail(arr[i]) === false){
              errorflag = true;
              break;
            }
          }
        }
      }
      if(errorflag) {
        return callback(new Error(this.$i18n.t('wm_lang_7b6234')+','+this.$i18n.t('wm_lang_58c224')+'3'+this.$i18n.t('wm_lang_930882')))
      } else {
        callback();
      }
    };
    let checkDefaultBccAddrs = (rule,value,callback) => {
      let errorflag = false;
      let addr = this.ruleFormBccDef;
      if(addr) {
        let arr = addr.split(",");
        if(arr.length > 3){
          errorflag = true;
        }else {
          for(let i= 0;i<arr.length;i++){
            if(isEmail(arr[i]) === false){
              errorflag = true;
              break;
            }
          }
        }
      }
      if(errorflag) {
        return callback(new Error(this.$i18n.t('wm_lang_7b6234')+','+this.$i18n.t('wm_lang_58c224')+'3'+this.$i18n.t('wm_lang_930882')))
      } else {
        callback();
      }
    };
    let checkCustomName = (rule,value,callback) => {
      let reg = /[@$￥#!%^&'<>\\"{}]/;
      if(reg.test(value) || (value && value.length > 128)) {
        return callback(new Error(this.$i18n.t('wm_lang_5c0086')+'128'+this.$i18n.t('wm_lang_15d410')+','+this.$i18n.t('wm_lang_098730')+' @$'+this.$i18n.t('wm_lang_0875ef')+'#!%^&\'<>\\"{}'))
      } else {
        callback();
      }
    };
    return {
      senderDisplayName: '',
      sendFromDisplayEnable: false,
      customSenderNameStatus: false,
      // 表单
      realName:this.$i18n.t('wm_lang_e5b49e'), // 登录后在全局config数据里读取（config后端暂未实现）
      ruleFormCcDef: "",
      ruleFormBccDef: "",
      ruleForm: {
        localConfigSetting: {},
        customSenderName: '',
        pageSize: 0,
        layout: 1,
        toolbarButtonIcon: true,
        loginRouterPage: 1,
        recvFromDisplay: 1,
        webmailSkin: 1,
        language: 1,
        sendFromDisplay: 1,
        customName: "",
        fontName: "",
        fontSize: 0,
        webSent: 1,
        receipt: false,
        replyWithContent: true,
        replySubjectPrefix: 1,
        orgVisible: true,
        ccDef: [],
        bccDef: []
      },
      rules: {
        ccDef: [
          { validator: checkDefaultCcAddrs, trigger: 'blur' },
        ],
        bccDef: [
          { validator: checkDefaultBccAddrs, trigger: 'blur' },
        ],
        customName: [
          { validator: checkCustomName, trigger: 'blur' },
        ]
      }
    }
  },
  mounted() {
    this.localConfigSetting = storeLocal.get('Pwm-configSetting');
    this.customSenderNameStatus = bitIs1(this.localConfigSetting.priviage.priviage1, 12);
    let self = this;
    (function (api, enums, pms) {
      api.Setting.queryMailAccountSetting({}, function (res) {
        console.log(res)
        if(res.data.code === 0) {
          self.ruleForm = res.data.data;
          if(!self.customSenderNameStatus) {
            self.ruleForm.sendFromDisplay = 2;
            self.sendFromDisplayEnable = true;
          }
          if(self.ruleForm.ccDef && self.ruleForm.ccDef.length > 0) {
            self.ruleFormCcDef = self.ruleForm.ccDef.toString();
          }
          if(self.ruleForm.bccDef && self.ruleForm.bccDef.length > 0) {
            self.ruleFormBccDef = self.ruleForm.bccDef.toString();
          }
        }
      })
    })(xmail.api, xmail.enums, xmail.pms);
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      if(this.ruleForm.sendFromDisplay === 3 && this.ruleForm.customName === '') {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_ce917f')
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          let self = this;
          (function (api, enums, pms) {
            // let pm = pms.Setting.saveMailAccountSettingParamBuilder();
            self.ruleForm.customSenderName = self.customSenderNameStatus; //后端要追加该值，前端回显不需要
            if(self.ruleForm.sendFromDisplay !== 3) {
              self.ruleForm.customName = '';
            }
            if(self.ruleFormCcDef) {
              self.ruleForm.ccDef = self.ruleFormCcDef.split(',');
            } else {
              self.ruleForm.ccDef = [];
            }
            if(self.ruleFormBccDef) {
              self.ruleForm.bccDef = self.ruleFormBccDef.split(',');
            } else {
              self.ruleForm.bccDef = [];
            }
            let pm = self.ruleForm;
            // console.log(pm);
            // return;
            api.Setting.saveMailAccountSetting(pm, function (res) {
              console.log(res)
              if(res.data.code === 0) {
                if(pm.layout === enums.Layout.LR){
                  Cookies.set('Pwm-set-layout','lr');
                } else {
                  Cookies.set('Pwm-set-layout','tb');
                }
                // let pmLang = 'cn';
                // switch (pm.language) {
                //   case 1:
                //     pmLang = 'cn';
                //     break;
                //   case 2:
                //     pmLang = 'hk';
                //     break;
                //   case 3:
                //     pmLang = 'en';
                //     break;
                // }
                // Cookies.set('PWM-language',pmLang);
                self.$EventBus.$emit("getConfigSetting");
                self.$message({
                  dangerouslyUseHTMLString: true,
                  message: '<strong>'+self.$i18n.t('wm_lang_314f60')+' <a href="/">'+self.$i18n.t('wm_lang_694fc5')+'</a>'+self.$i18n.t('wm_lang_5f6025')+'</strong>'
                });
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
  @media only screen and (min-width:993px) {
    .custom-name-error {
      margin-left: 278px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/generalSettings.vue